import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { Dropdown, Grid } from 'semantic-ui-react';
import { useMsal, useAccount } from '@azure/msal-react';

import { POSImage } from '@publicisgroupe/p-os-components';
import { useEnvironment } from '@publicisgroupe/p-os-components/build/contexts/EnvironmentContext';

import { useUserContext } from 'contexts/AuthProvider';
import useWebframePermissions from 'hooks/useWebframePermissions';
import { t } from 'utils/resources';
import { NavigationItemDto } from 'types/types';
import { ROUTE_ROOT } from 'utils/routes';

import { DashboardMobile } from './DashboardMobile';
import { DashboardWidescreens } from './DashboardWidescreens';

import './Dashboard.less';

export type UserRole = {
  key: string;
  text: string;
  value: string;
  content: string;
};

export const Dashboard = () => {
  const [filters, setFilters] = useState<NavigationItemDto[]>([]);
  const [filterNames, setFilterNames] = useState<string[]>([]);
  const options: UserRole[] = [];

  const { accounts } = useMsal();
  const account = useAccount(accounts[0] || {});
  const { settings } = useEnvironment();
  const { navData } = useUserContext();
  const history = useHistory();

  const { isGranted } = useWebframePermissions();

  // these should be loaded from some api, not hardcoded
  const business = [
    'Client Lead',
    'New Business',
    'Planner',
    'Strategist',
    'Data Scientist',
    'Investment',
    'Creative',
    'Producer',
  ];

  business.forEach((role) => {
    options.push({
      key: role,
      text: role,
      value: role,
      content: role,
    });
  });

  useEffect(() => {
    if (navData.length > 0) {
      const filterNamesData = navData[0].filters;
      const filtersData = navData ?? [];
      setFilterNames(filterNamesData);
      setFilters(filtersData);
    }
  }, [navData]);

  useEffect(() => {
    const initialFilterPermission = !isGranted('Webframe.Login.InitialFilterView');

    if (initialFilterPermission !== undefined && !initialFilterPermission) {
      history.replace(ROUTE_ROOT);
    }
    // Comment needed to remove the dependencies. Because we need this useEffect
    // work only once when component is mounted. Fix for bug POS-2504.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {isGranted('Webframe.Login.InitialFilterView') && (
        <div className="dashboard-context">
          <Grid.Column className="computer only widescreen only large screens only">
            <div className="large-screen-measurements">
              <div
                className="cockpit-background"
                style={{
                  background: `url(${settings.cdnBaseUrl}/webframe/cockpit_template.png)`,
                }}
              ></div>
              <Grid verticalAlign="middle" columns="equal" centered stackable padded>
                <Grid.Column width={6}>
                  <div className="user-details">
                    <h1>
                      {t('Dashboard.Welcome')} <br />
                      {account?.name}
                    </h1>
                    <p className="logged-in-as">{t('Dashboard.LoggedIn')}</p>
                    <Dropdown inline options={options} defaultValue={options[0].value} />
                  </div>
                  <div className="brand-logo">
                    <POSImage src="webframe/logo-Primary-Dark-bg.svg" />
                  </div>
                </Grid.Column>
                <Grid.Column width={2}></Grid.Column>
                <Grid.Column>
                  <h3>{t('Dashboard.Title')}</h3>
                  <DashboardWidescreens filters={filters} filterNames={filterNames} />
                </Grid.Column>
              </Grid>
            </div>
          </Grid.Column>
          <Grid.Column className="tablet only mobile only">
            <div className="mobile-screen-measurements">
              <div
                className="mobile-background"
                style={{
                  background: `url(${settings.cdnBaseUrl}/webframe/mobile-dashboard-bg.png)`,
                }}
              ></div>
              <DashboardMobile filters={filters} filterNames={filterNames} />
            </div>
          </Grid.Column>
        </div>
      )}
    </>
  );
};
